module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('v-contactmodal'), _vm._v(" "), _c('v-sidebar', {
    attrs: {
      "activeNavItem": "navLink1"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "main-panel"
  }, [_c('v-navbar', {
    attrs: {
      "title": 'RFQ Detail'
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        return _vm.dissmissAutoCompletes()
      }
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("RFQ Details (" + _vm._s(_vm.level) + ")")])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.status),
      expression: "status"
    }],
    staticClass: "form-control",
    staticStyle: {
      "-webkit-appearance": "none",
      "-webkit-border-radius": "0px"
    },
    attrs: {
      "id": "statusselect"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.status = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', [_vm._v("Open")]), _vm._v(" "), _c('option', [_vm._v("Assigned")]), _vm._v(" "), _c('option', [_vm._v("Customer Review")]), _vm._v(" "), _c('option', [_vm._v("Sent for Review")]), _vm._v(" "), _c('option', [_vm._v("Completed")]), _vm._v(" "), _c('option', [_vm._v("Archived")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('button', {
    staticClass: "btn btn-warning",
    attrs: {
      "id": "statusbutton"
    },
    on: {
      "click": function($event) {
        return _vm.changeStatus()
      }
    }
  }, [_vm._v("Change Status")])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('button', {
    staticClass: "btn btn-success",
    on: {
      "click": function($event) {
        return _vm.getRFQPDF()
      }
    }
  }, [_vm._v("Get PDF Summary")])])])])])])]), _vm._v(" "), _c('h4', [_c('font', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.rfqErrorMessage) + " ")])], 1), _vm._v(" "), _c('UploadDocument', {
    attrs: {
      "showGenerate": true,
      "documents": _vm.documents,
      "rfqId": _vm.rfqIdOnly,
      "rfq": _vm.rfq
    },
    on: {
      "fileUploaded": _vm.saveDocumentToRFQ,
      "deleteUploadedDocument": _vm.deleteDocument
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("RFQ Customer Details")]), _vm._v(" "), _c('small', {
    staticClass: "text-muted"
  }, [_vm._v(_vm._s(_vm.rfqIdOnly))])]), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Customer")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.cuscompany))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.cusaddress) + ", " + _vm._s(_vm.cuscity) + ", " + _vm._s(_vm.cusprovince)), _c('br'), _vm._v(_vm._s(_vm.cuspostal)), _c('br'), _vm._v(_vm._s(_vm.cuscountry))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Terms")]), _c('br'), _vm._v(_vm._s(_vm.custerms))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Due Date")]), _c('br'), _vm._v(_vm._s(_vm.cusduedate))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.cuspo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Sales #")]), _c('br'), _vm._v(_vm._s(_vm.cussales))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Transfer Order #")]), _c('br'), _vm._v(_vm._s(_vm.custransferorder))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Shipper")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.shicompany))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.shipo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Release #")]), _c('br'), _vm._v(_vm._s(_vm.shirelease))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.shiaddress) + ", " + _vm._s(_vm.shicity) + ", " + _vm._s(_vm.shiprovince)), _c('br'), _vm._v(_vm._s(_vm.shipostal)), _c('br'), _vm._v(_vm._s(_vm.shicountry))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v(_vm._s(_vm.shiappointment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Liftgate")]), _c('br'), _vm._v(_vm._s(_vm.shiliftgate))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Pick Up Date")]), _c('br'), _vm._v(_vm._s(_vm.shipickupdate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3 border-right"
  }, [_c('h5', [_vm._v("Consignee")]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Company / Name")]), _c('br'), _vm._v(_vm._s(_vm.conname))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("PO #")]), _c('br'), _vm._v(_vm._s(_vm.conpo))]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Address")]), _c('br'), _vm._v(_vm._s(_vm.conaddress) + ", " + _vm._s(_vm.concity) + ", " + _vm._s(_vm.conprovince)), _c('br'), _vm._v(_vm._s(_vm.conpostal)), _c('br'), _vm._v(_vm._s(_vm.concountry))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Appointment")]), _c('br'), _vm._v(_vm._s(_vm.conappointment))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Liftgate")]), _c('br'), _vm._v(_vm._s(_vm.conliftgate))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Delivery")]), _c('br'), _vm._v(_vm._s(_vm.condeliverydate))])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 col-sm-3"
  }, [_c('h5', [_vm._v("Truck")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Trailer Type")]), _c('br'), _vm._v(_vm._s(_vm.trtrailertype))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Suspension Type")]), _c('br'), _vm._v(_vm._s(_vm.trsuspensiontype))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Temperature Control")]), _c('br'), _vm._v(_vm._s(_vm.trtempcontrol))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("COD")]), _c('br'), _vm._v(_vm._s(_vm.trcod))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Driver Assist")]), _c('br'), _vm._v(_vm._s(_vm.trdriverassist))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Mode")]), _c('br'), _vm._v(_vm._s(_vm.trmode))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Service")]), _c('br'), _vm._v(_vm._s(_vm.trservice))])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Dunnage Required")]), _c('br'), _vm._v(_vm._s(_vm.trdunnagerequired))])])]), _vm._v(" "), _c('p', [_c('small', {
    staticClass: "text-muted"
  }, [_vm._v("Special Instructions")]), _c('br'), _vm._v(_vm._s(_vm.trspecialinstructions))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "id": "modifyrfqcard"
    }
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', [_vm._l((_vm.quoterows), function(quoterow) {
    return [_c('tr', [_c('td', [_vm._v(_vm._s(quoterow.customer) + " ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.duedate))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.from))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.to))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.pickup))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.delivery))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.basecharge == "N/A" ? quoterow.basecharge : ("$" + quoterow.basecharge)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.handlingcharge == "N/A" ? quoterow.handlingcharge : ("$" + quoterow.handlingcharge)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.bordercharge == "N/A" ? quoterow.bordercharge : ("$" + quoterow.bordercharge)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.fuelcharge == "N/A" ? quoterow.fuelcharge : ("$" + quoterow.fuelcharge)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.additionalcharge == "N/A" ? quoterow.additionalcharge : ("$" + quoterow.additionalcharge)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(quoterow.charge == "N/A" ? quoterow.charge : ("$" + quoterow.charge)))]), _vm._v(" "), _c('td', {
      staticClass: "text-right"
    }, [_c('button', {
      staticClass: "btn btn-sm btn-secondary",
      class: quoterow.messageclass,
      attrs: {
        "name": "selectquotebutton"
      },
      on: {
        "click": function($event) {
          return _vm.selectQuote(quoterow)
        }
      }
    }, [_vm._v("Select Quote")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-secondary",
      class: quoterow.messageclass2,
      attrs: {
        "name": "finishquotebutton"
      },
      on: {
        "click": function($event) {
          return _vm.finishQuote(quoterow)
        }
      }
    }, [_vm._v("Finish Quote")]), _vm._v(_vm._s(quoterow.message) + "\n                            "), _c('button', {
      staticClass: "btn btn-sm btn-success",
      class: quoterow.messageclassFinal,
      on: {
        "click": function($event) {
          return _vm.acceptQuote(quoterow)
        }
      }
    }, [_vm._v("Accept Quote")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-danger",
      class: quoterow.messageclassFinal,
      on: {
        "click": function($event) {
          return _vm.rejectQuote($event, quoterow)
        }
      }
    }, [_vm._v("Reject Quote")])])])]
  })], 2)]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "reworkQuoteDiv"
    }
  }, [_c('p', [_vm._v("You can either permanently close this RFQ.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "id": "closeRFQButton"
    },
    on: {
      "click": function($event) {
        return _vm.rejectRFQServer(false)
      }
    }
  }, [_vm._v("Close/Archive RFQ")]), _vm._v(" "), _c('br'), _c('br'), _c('p', [_vm._v("Or you can rework it by selecting a different quote.")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "id": "reworkRFQButton"
    },
    on: {
      "click": function($event) {
        return _vm.rejectRFQServer(true)
      }
    }
  }, [_vm._v("Rework RFQ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none",
      "width": "40%"
    },
    attrs: {
      "id": "selectmarkupstyle"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("Markup")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markup),
      expression: "markup"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Enter % Markup Here",
      "id": "markup",
      "name": "markup"
    },
    domProps: {
      "value": (_vm.markup)
    },
    on: {
      "keyup": function($event) {
        return _vm.markupCalculator()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.markup = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("%")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.markupnotes),
      expression: "markupnotes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Optional notes or comments",
      "id": "markupnotes",
      "name": "markupnotes"
    },
    domProps: {
      "value": (_vm.markupnotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.markupnotes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "input-group"
  }, [_c('div', [_vm._v("Total Cost = $"), _c('b', [_vm._v(_vm._s(_vm.markupNewTotal))])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding-top": "10px",
      "left": "36%",
      "position": "relative"
    }
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        return _vm.cancelReloadPage()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" \n                            "), _c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "id": "markupbutton"
    },
    on: {
      "click": function($event) {
        return _vm.submitMarkup()
      }
    }
  }, [_vm._v("Submit Markup")])])])]), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-success quoteButton",
    attrs: {
      "id": "addQuoteButton"
    },
    on: {
      "click": function($event) {
        return _vm.addQuote()
      }
    }
  }, [_vm._v("Add Quote")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addquoteform"
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotefromlocation"
    }
  }, [_vm._v("From Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotefromlocation),
      expression: "quotefromlocation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.quotefromlocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotefromlocation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotefromlocation"
    }
  }, [_vm._v("To Location")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotetolocation),
      expression: "quotetolocation"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.quotetolocation)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotetolocation = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quoteshipickupdate"
    }
  }, [_vm._v("Pick Up")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quoteshipickupdate),
      expression: "quoteshipickupdate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    ref: "quoteshipickupdate",
    staticClass: "form-control datetimepicker",
    attrs: {
      "type": "text",
      "name": "quote pick up"
    },
    domProps: {
      "value": (_vm.quoteshipickupdate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quoteshipickupdate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotedeliverydate"
    }
  }, [_vm._v("Delivery")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotedeliverydate),
      expression: "quotedeliverydate"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|validDate'),
      expression: "'required|validDate'"
    }],
    ref: "quotedeliverydate",
    staticClass: "form-control datetimepicker",
    attrs: {
      "type": "text",
      "name": "quote delivery"
    },
    domProps: {
      "value": (_vm.quotedeliverydate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotedeliverydate = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotefromlocation"
    }
  }, [_vm._v("Transit Time")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotetransittime),
      expression: "quotetransittime"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.quotetransittime)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotetransittime = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "basecharge"
    }
  }, [_vm._v("Base Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotebasecharge),
      expression: "quotebasecharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "basecharge",
      "name": "basecharge"
    },
    domProps: {
      "value": (_vm.quotebasecharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotebasecharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "fuelcharge"
    }
  }, [_vm._v("Fuel Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotefuelcharge),
      expression: "quotefuelcharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "fuelcharge",
      "name": "fuelcharge"
    },
    domProps: {
      "value": (_vm.quotefuelcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotefuelcharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bordercharge"
    }
  }, [_vm._v("Border Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotebordercharge),
      expression: "quotebordercharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "bordercharge",
      "name": "bordercharge"
    },
    domProps: {
      "value": (_vm.quotebordercharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotebordercharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "handlingcharge"
    }
  }, [_vm._v("Handling Charge")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotehandlingcharge),
      expression: "quotehandlingcharge"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "handlingcharge",
      "name": "handlingcharge"
    },
    domProps: {
      "value": (_vm.quotehandlingcharge)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotehandlingcharge = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "bordercharge"
    }
  }, [_vm._v("Additional Charges")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quoteadditionalcharges),
      expression: "quoteadditionalcharges"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "additionalcharges",
      "name": "additionalcharges"
    },
    domProps: {
      "value": (_vm.quoteadditionalcharges)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quoteadditionalcharges = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotenotes"
    }
  }, [_vm._v("Quote Notes")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotenotes),
      expression: "quotenotes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "quotenotes",
      "name": "quotenotes"
    },
    domProps: {
      "value": (_vm.quotenotes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotenotes = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "quotenumber"
    }
  }, [_vm._v("Quote Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.quotenumber),
      expression: "quotenumber"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "quotenumber",
      "name": "quotenumber"
    },
    domProps: {
      "value": (_vm.quotenumber)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.quotenumber = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._l((_vm.errors.all()), function(error) {
    return _c('p', {
      staticClass: "help is-danger"
    }, [_vm._v(_vm._s(error))])
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('button', {
    staticClass: "btn btn-secondary",
    on: {
      "click": function($event) {
        return _vm.cancelReloadPage()
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" \n                          "), _c('button', {
    staticClass: "btn btn-success quoteButton",
    attrs: {
      "id": "submitquotebutton"
    },
    on: {
      "click": _vm.beforeSubmitQuote
    }
  }, [_vm._v("Submit Quote")])])], 2)])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12",
    attrs: {
      "id": "addAssigneeSection"
    }
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("New Assignee")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigneename),
      expression: "assigneename"
    }],
    staticClass: "form-control typeahead",
    attrs: {
      "type": "text",
      "autocomplete": "off",
      "placeholder": "Name/Company",
      "disabled": _vm.submitingAssignee
    },
    domProps: {
      "value": (_vm.assigneename)
    },
    on: {
      "keyup": function($event) {
        return _vm.assigneeLiveSearch()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assigneename = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "customLiveSearch",
    staticStyle: {
      "margin-top": "-14px"
    },
    attrs: {
      "id": "assigneeCustomLiveSearch"
    }
  }, [_vm._l((_vm.assigneerows), function(assigneerow, index) {
    return [_c('div', {
      key: index,
      staticClass: "customLiveSearchElement",
      on: {
        "click": function($event) {
          return _vm.assigneeSelected(assigneerow)
        }
      }
    }, [_vm._v(_vm._s(assigneerow.email + " (" + assigneerow.name + ")"))])]
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.assigneeduedate),
      expression: "assigneeduedate"
    }],
    staticClass: "form-control datetimepicker",
    attrs: {
      "type": "text",
      "placeholder": "Due Date",
      "disabled": _vm.submitingAssignee
    },
    domProps: {
      "value": (_vm.assigneeduedate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.assigneeduedate = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "btn btn-icon btn-xs btn-success",
    attrs: {
      "disabled": _vm.submitingAssignee
    },
    on: {
      "click": function($event) {
        return _vm.assignRFQ()
      }
    }
  }, [_vm._v("Send")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "card"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-borderless"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center squeeze"
  }), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "320px",
      "max-width": "320px"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_vm._v("Description / Lot")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Quantity")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Stackable")]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Length " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Width " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Height " + _vm._s(_vm.suunitlength))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Weight " + _vm._s(_vm.suunitweight))]), _vm._v(" "), _c('th', {
    staticClass: "text-center"
  }, [_vm._v("Hazard")]), _vm._v(" "), _c('th', {
    staticClass: "text-left",
    staticStyle: {
      "min-width": "120px",
      "max-width": "120px"
    }
  }, [_vm._v("Contents")]), _vm._v(" "), _c('th', {
    staticClass: "text-center squeeze"
  })])]), _vm._v(" "), _c('tbody', [_vm._l((_vm.detailrows), function(row, shipIndex) {
    return [_c('TertiaryRow', {
      key: 'tertiary_' + shipIndex,
      attrs: {
        "row": row,
        "shipIndex": shipIndex,
        "readOnly": true
      },
      on: {
        "removeRow": null,
        "cloneRow": null
      }
    })]
  })], 2)])])])])])]), _vm._v(" "), (_vm.detailrows.length > 0) ? _c('ShippingSummary', {
    ref: "summary",
    attrs: {
      "rfq": _vm.rfq,
      "rows": _vm.detailrows,
      "density": _vm.density,
      "densityClass": _vm.densityclass,
      "totalWeight": _vm.totalWeight,
      "totalWeightKg": _vm.totalWeightKg
    }
  }) : _vm._e(), _vm._v(" "), _vm._m(3)], 1), _vm._v(" "), _c('v-footer')], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Assignee Quotes")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Due Date")]), _vm._v(" "), _c('th', [_vm._v("From")]), _vm._v(" "), _c('th', [_vm._v("To")]), _vm._v(" "), _c('th', [_vm._v("Pickup")]), _vm._v(" "), _c('th', [_vm._v("Delivery")]), _vm._v(" "), _c('th', [_vm._v("Base Charge")]), _vm._v(" "), _c('th', [_vm._v("Handling Charge")]), _vm._v(" "), _c('th', [_vm._v("Border Charge")]), _vm._v(" "), _c('th', [_vm._v("Fuel Charge")]), _vm._v(" "), _c('th', [_vm._v("Additional Charge")]), _vm._v(" "), _c('th', [_vm._v("Total Charge")]), _vm._v(" "), _c('th')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "card-header"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Shipping Units")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticClass: "btn btn-success btn-wd",
    attrs: {
      "href": "#/rfq/view"
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-left"
  }), _vm._v(" Back")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-481a2724"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/rfq/detail.vue
// module id = 703
// module chunks = 0